import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

import { IFRConcursos } from './concursos.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ConcursosService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public get(limit, skip, filters = {}, conds = {}, ordering = {}, exportar = false): Observable<IFRConcursos[]> {
   let params = new HttpParams();

    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    params = params.append('export', exportar?'true':'false');

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }
    return this.authHttp.get<IFRConcursos[]>(encodeURI(APIURLConstantsService._API_BASE_URL + 'concursos?limit='+limit+'&skip='+skip), this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  constructor(private authHttp: HttpClient) { }

}
